class CartPromoModal {
  constructor() {
    this.documentClickHandler = this.handleDocumentClick.bind(this);
    this.formSubmitHandler = this.handleSubmit.bind(this);
    this.assignElements();
    if (!this.modal) return;

    document.addEventListener("click", this.documentClickHandler);
    this.form?.addEventListener("submit", this.formSubmitHandler);
    this.clearClickHandler = this.handleClear.bind(this);
    this.clearButton?.addEventListener("click", this.clearClickHandler);
  }

  assignElements() {
    this.modal = document.querySelector("[data-promo-modal]");
    if (!this.modal) return;

    this.activeTrigger = null;
    this.input = this.modal.querySelector("[data-promo-input]");
    this.status = this.modal.querySelector("[data-promo-status]");
    this.form = this.modal.querySelector("[data-promo-form]");
    this.submitButton = this.modal.querySelector("[data-promo-submit]");
    this.clearButton = this.modal.querySelector("[data-promo-clear]");
  }

  destroy() {
    document.removeEventListener("click", this.documentClickHandler);
    this.form?.removeEventListener("submit", this.formSubmitHandler);
    this.clearButton?.removeEventListener("click", this.clearClickHandler);
  }

  handleDocumentClick(event) {
    const openTrigger = event.target.closest("[data-promo-drawer-trigger]");
    if (openTrigger) {
      event.preventDefault();
      this.open(openTrigger);
      return;
    }

    const removeTrigger = event.target.closest("[data-promo-remove]");
    if (removeTrigger) {
      event.preventDefault();
      this.removeCode(removeTrigger);
      return;
    }

    if (event.target.closest("[data-promo-close]")) {
      event.preventDefault();
      this.close();
    }
  }

  open(trigger) {
    this.activeTrigger = trigger;
    this.modal.classList.add("is-open");
    this.modal.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      this.input?.focus();
    });
  }

  close() {
    this.modal.classList.remove("is-open");
    this.modal.setAttribute("aria-hidden", "true");
    this.setStatus("");
    if (this.input) this.input.value = "";
    this.setLoading(false);

    if (this.activeTrigger) {
      this.activeTrigger.focus();
      this.activeTrigger = null;
    }
  }

  setLoading(state) {
    if (!this.submitButton) return;
    this.submitButton.toggleAttribute("disabled", state);
    this.submitButton.classList.toggle("is-loading", state);
  }

  setStatus(message, isError = false) {
    if (!this.status) return;

    if (message) {
      this.status.textContent = message;
      this.status.hidden = false;
      this.status.classList.toggle("is-error", isError);
    } else {
      this.status.textContent = "";
      this.status.hidden = true;
      this.status.classList.remove("is-error");
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const code = this.input?.value.trim();
    if (!code) {
      this.setStatus(window.cartPromoStrings?.empty || "Introduce un código.", true);
      return;
    }

    this.applyCode(code);
  }

  applyCode(code) {
    this.setLoading(true);
    this.setStatus("");

    const body = JSON.stringify({ discount: code });

    fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), body })
      .then((response) => {
        if (!response.ok) {
          throw new Error("invalid");
        }
        return response.json();
      })
      .then(() => {
        const successMessage =
          window.cartPromoStrings?.success?.replace("{{ code }}", code) ||
          `Código aplicado: ${code}`;
        this.setStatus(successMessage, false);
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
        setTimeout(() => this.close(), 1200);
      })
      .catch(() => {
        this.setStatus(window.cartPromoStrings?.error || "Código no válido.", true);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  removeCode(button) {
    button?.setAttribute("disabled", "disabled");
    button?.classList.add("is-loading");

    const body = JSON.stringify({ discount: "" });

    fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), body })
      .then((response) => {
        if (!response.ok) {
          throw new Error("remove-failed");
        }
        return response.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      })
      .catch(() => {
        console.error("Failed to remove discount code");
      })
      .finally(() => {
        button?.removeAttribute("disabled");
        button?.classList.remove("is-loading");
      });
  }

  handleClear(event) {
    event.preventDefault();
    if (!this.input) return;

    this.input.value = "";
    this.setStatus("");
    this.input.focus();
  }
}

let cartPromoModalInstance;

function initCartPromoModal() {
  if (cartPromoModalInstance) {
    cartPromoModalInstance.destroy();
  }
  cartPromoModalInstance = new CartPromoModal();
}

document.addEventListener("DOMContentLoaded", initCartPromoModal);
document.addEventListener("cart-drawer:refreshed", initCartPromoModal);
